import { ReactElement } from 'react';
import { DashboardContainer } from '../../../modules/common/dashboard/DashboardContainer';
import { JobsHeaderContainer } from '../../../modules/jobs/containers/list/JobsHeader.container';
import { JobsListContainer } from '../../../modules/jobs/containers/list/JobsList.container';
import { JOB_TYPE } from '../../../modules/jobs/jobs.model';

export const InferencesView = (): ReactElement => {
  return (
    <DashboardContainer>
      <JobsHeaderContainer jobType={JOB_TYPE.INFERENCE} />
      <JobsListContainer jobType={JOB_TYPE.INFERENCE} />
    </DashboardContainer>
  );
};
